import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=9b46e712&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=9b46e712&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b46e712",
  null
  
)

export default component.exports